import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-cta").forEach((el) => {
	initOnScrollAnimation(el);

	ScrollTrigger.create({
		trigger: el,
		start: "top bottom",
		scrub: true,
		end: "bottom top",
		animation: gsap.fromTo(el, { y: "2rem" }, { y: "-2rem" }),
	});
});
